/* PurePetZone — carrello a scomparsa.

   Quattro compiti:
   1. intercettare gli invii dei moduli prodotto, cosi' "Aggiungi al carrello"
      non ricarica piu' la pagina e il carrello si apre SUBITO;
   2. intercettare i collegamenti al carrello, che devono aprire il pannello
      invece di portare via dalla pagina;
   3. RIFARE IL CARRELLO ALLA CONFEZIONE GIUSTA: il piu' e il meno lavorano sui
      PEZZI, non sulle confezioni. Da 1 pezzo a 2 non si mettono due confezioni
      singole a 30 euro l'una, si passa alla confezione da 2 che ne costa 40.
      Lo stesso vale quando si aggiunge due volte lo stesso prodotto dalla
      scheda: il carrello si accorpa da solo sull'offerta migliore;
   4. tenere aggiornato il contenuto chiedendo a Shopify di ridisegnare la sola
      sezione del carrello.

   I PREZZI NON LI CALCOLA MAI QUESTO FILE. Qui si decide solo QUALI varianti
   mettere e in che numero; l'importo, lo sconto e la percentuale li stampa
   Liquid dentro la sezione. Cosi' non possono esistere due verita' sui totali.

   Tutti gli ascolti sono sul documento (delega): il contenuto del pannello
   viene sostituito di continuo, e agganciare i tasti uno per uno vorrebbe dire
   riagganciarli a ogni ricalcolo. */

(function () {
  'use strict';

  var SEZIONE = 'ppz-cart-drawer';
  var CHIAVE_TIMER = 'ppz-cart-hold';
  var MAX_PEZZI = 99;

  var radice = null;
  var ultimoFuoco = null;
  var conto = null;

  function trova() {
    radice = document.querySelector('[data-ppz-cart]');
    return radice;
  }

  /* --- Apertura e chiusura ------------------------------------------------ */

  function apri() {
    if (!trova()) return;
    if (radice.hasAttribute('data-open')) return;
    ultimoFuoco = document.activeElement;
    radice.hidden = false;
    /* Due giri di disegno: il primo mostra l'elemento, il secondo fa partire lo
       scorrimento. Insieme sarebbe un salto secco. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { radice.setAttribute('data-open', ''); });
    });
    document.body.style.overflow = 'hidden';
    var x = radice.querySelector('[data-ppz-cart-close]');
    if (x && x.focus) x.focus({ preventScroll: true });
    avviaConto();
  }

  function chiudi() {
    if (!radice) return;
    radice.removeAttribute('data-open');
    document.body.style.overflow = '';
    window.setTimeout(function () { if (radice) radice.hidden = true; }, 280);
    if (ultimoFuoco && ultimoFuoco.focus) ultimoFuoco.focus();
  }

  /* UNA MODIFICA PER VOLTA. Prima era il CSS a garantirlo: `data-loading` sul
     pannello spegneva i clic su tutto il corpo. Smorzando solo la riga toccata
     quel lucchetto era sparito, e con due «piu'» partiti insieme su righe
     diverse vinceva la risposta piu' vecchia, il conteggio ballava e il tasto
     della cassa restava premibile col totale ancora vecchio. Il lucchetto
     adesso e' qui, esplicito. */
  /* Mentre una modifica e' in volo il pannello si smorza TUTTO e il CSS spegne i
     clic sul corpo: una operazione per volta, senza bisogno di tenere uno stato
     in JavaScript.

     PROVATO E TOLTO il 09/09/2026, non riprovarci senza rifare il giro intero:
     si era smorzata solo la riga toccata e si scriveva subito il numero nuovo
     senza aspettare il server, per farlo sembrare istantaneo. Sembrava una
     bella idea e ha aperto una voragine — tre giri di controllo, difetti che
     rompono ogni volta, e ognuno nato dalla riparazione del giro prima:
     smorzando una riga sola spariva il lucchetto e due «piu'» partivano
     insieme, vinceva la risposta piu' vecchia e il tasto della cassa restava
     premibile col totale vecchio; mettendo un lucchetto in JavaScript,
     chiudendo il pannello a meta' il lucchetto restava chiuso e «Aggiungi al
     carrello» si mangiava il tocco in silenzio; e senza un tempo massimo sulle
     richieste bastava perdere campo per lasciare il carrello morto fino al
     ricaricamento della pagina.
     Il guadagno era mezzo secondo di sensazione. Il costo era un carrello che
     puo' mentire sui soldi. Non vale. */
  /* 06/10/2026: e' un CONTATORE, non un si'/no. L'allineamento dei regali
     all'apertura della pagina puo' finire mentre un'aggiunta al carrello
     aspetta il suo turno: chi finisce per primo non deve riaprire il pannello
     all'altro. Ogni `occupato(true)` ha il suo `occupato(false)`. */
  var lavori = 0;

  function occupato(si) {
    lavori = Math.max(0, lavori + (si ? 1 : -1));
    if (!radice) return;
    if (lavori > 0) radice.setAttribute('data-loading', '');
    else radice.removeAttribute('data-loading');
  }

  /* --- Ridisegno ----------------------------------------------------------- */

  /* Il pannello si ridisegna con l'HTML che Shopify ha gia' mandato INSIEME alla
     modifica del carrello: `/cart/add.js` e `/cart/change.js` accettano il
     parametro `sections` e restituiscono la sezione gia' renderizzata.

     Prima si facevano DUE viaggi in fila — prima la modifica, poi
     `/?sections=...` — e il secondo da solo costava 212 ms misurati (min 166,
     max 298), piu' della modifica stessa. Chiedendo tutto in una volta il
     secondo viaggio sparisce: l'attesa passa da ~400 ms a ~200 ms su ogni «+»,
     «-», cestino e aggiunta al carrello.

     `ridisegna()` senza argomenti resta valida e va a prendersi la sezione da
     sola: serve per i casi in cui l'HTML non e' arrivato (apertura del pannello,
     accorpamento, risposta senza `sections`). */
  function ridisegna(dati) {
    var pronto = dati && dati.sections && dati.sections[SEZIONE];
    if (pronto) return applicaHtml(dati.sections[SEZIONE]);
    return fetch('/?sections=' + SEZIONE)
      .then(function (r) { return r.json(); })
      .then(function (dati) { return applicaHtml(dati[SEZIONE]); })
      .catch(function () { /* se la rete non risponde il pannello resta com'e' */ });
  }

  /* LE FOTO ARRIVANO INSIEME AL RESTO (27/09/2026, lui: «il carrello è lento,
     carica la foto dopo»). L'HTML nuovo viene letto in un pezzo staccato dalla
     pagina: le sue foto partono gia' li'. Si aspetta che siano pronte — al
     massimo 450 ms, poi si mostra comunque — e si SPOSTANO nel pannello gli
     stessi elementi, gia' scaricati e decodificati. Prima il testo compariva
     subito e le foto dopo, una alla volta. */
  function fotoPronte(el) {
    var foto = Array.prototype.slice.call(el.querySelectorAll('img'));
    if (!foto.length) return Promise.resolve();
    var tutte = Promise.all(foto.map(function (img) {
      if (img.decode) return img.decode().catch(function () {});
      return new Promise(function (ok) {
        if (img.complete) return ok();
        img.onload = img.onerror = ok;
      });
    }));
    var tetto = new Promise(function (ok) { window.setTimeout(ok, 450); });
    return Promise.race([tutte, tetto]);
  }

  function applicaHtml(html) {
    if (!html || !trova()) return Promise.resolve();
    var finto = document.createElement('div');
    finto.innerHTML = html;
    return fotoPronte(finto).then(function () { mettiHtml(finto); });
  }

  function mettiHtml(finto) {
    if (!trova()) return;
    var nuovo = finto.querySelector('[data-ppz-cart-swap]');
    var vecchio = radice.querySelector('[data-ppz-cart-swap]');

    /* Dove si era arrivati a scorrere: sostituendo l'interno l'elenco tornava
       in cima a ogni «piu'», e con qualche riga nel carrello si perdeva di
       vista proprio quella che si stava cambiando. */
    var corpoVecchio = radice.querySelector('.ppz-cart__body');
    var scorrimento = corpoVecchio ? corpoVecchio.scrollTop : 0;

    /* Si sostituisce SOLO l'interno: il pannello di fuori tiene lo stato
       aperto, e rimpiazzandolo il carrello si chiuderebbe da solo. */
    if (nuovo && vecchio) {
      /* Si spostano gli elementi, non si ricopia l'HTML: ricopiandolo le foto
         appena preparate verrebbero ricreate da capo. */
      while (vecchio.firstChild) vecchio.removeChild(vecchio.firstChild);
      while (nuovo.firstChild) vecchio.appendChild(nuovo.firstChild);
      vecchio.setAttribute('data-pezzi-totali', nuovo.getAttribute('data-pezzi-totali') || '0');
    }

    /* Il pannello vero ha preso il posto della riga provvisoria (se c'era): da qui
       in poi il pannello e' quello di Shopify, aggiornato. */
    radice.removeAttribute('data-attesa');
    forseVecchio = false;

    if (scorrimento) {
      var corpoNuovo = radice.querySelector('.ppz-cart__body');
      if (corpoNuovo) corpoNuovo.scrollTop = scorrimento;
    }
    /* Il numerino sull'icona conta i pezzi, non le righe: il conto giusto
       lo sa solo Liquid, e lo passa qui nell'attributo. */
    if (vecchio) aggiornaIcona(parseInt(vecchio.getAttribute('data-pezzi-totali'), 10) || 0);
    nascondiRifiutati();
    avviaConto();
  }

  /* Il numerino sull'icona del carrello nell'intestazione: l'intestazione non fa
     parte del pezzo che ridisegniamo, quindi va aggiornata a mano. */
  function aggiornaIcona(quanti) {
    var cart = document.querySelector('.ppz-header__cart');
    if (!cart) return;
    var badge = cart.querySelector('.ppz-header__count');
    if (quanti > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ppz-header__count';
        badge.setAttribute('aria-hidden', 'true');
        cart.appendChild(badge);
      }
      badge.textContent = quanti;
    } else if (badge) {
      badge.remove();
    }
  }

  /* --- La scala delle confezioni ------------------------------------------- */

  function scala() {
    var el = document.querySelector('[data-ppz-cart-scala]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  /* Il prezzo con cui fare i conti: quello a consegna dell'abbonamento se si
     sta lavorando su una riga abbonata, quello una tantum altrimenti. Tutti e
     due arrivano da Shopify attraverso la tabella qui sopra: in questo file non
     c'e' nessuna percentuale scritta a mano, percio' un prezzo cambiato dal
     pannello si riflette qui senza toccare niente. */
  /* QUALE piano usare per una confezione, quando si sta lavorando in
     abbonamento.

     All'inizio l'abbonamento era UNO SOLO, agganciato al prodotto intero, e
     tutte le confezioni ne condividevano l'identificativo. Dall'08/09/2026 non
     e' piu' cosi': in Kaching c'e' un piano PER CONFEZIONE (uno per la singola,
     uno per la doppia, uno per la tripla), ognuno con il suo identificativo e
     il suo prezzo. Quindi non si cerca piu' "lo stesso piano della riga": si
     prende il piano CHE QUELLA CONFEZIONE HA. Se per caso ne avesse piu' d'uno
     si tiene quello della riga, altrimenti il primo. */
  function pianoDi(c, piano) {
    if (!piano || !c || !c.piani) return '';
    if (typeof c.piani[piano] === 'number') return piano;
    var chiavi = Object.keys(c.piani);
    return chiavi.length ? chiavi[0] : '';
  }

  function prezzoDi(c, piano) {
    var suo = pianoDi(c, piano);
    if (suo) return c.piani[suo];
    return c.prezzo;
  }

  /* Dato un numero di PEZZI, quale insieme di confezioni costa meno.

     Non e' una scelta a occhio ("prendi sempre la piu' grande"): quella e'
     giusta con questi tre prezzi, ma smetterebbe di esserlo il giorno in cui
     una confezione viene ritoccata. Qui si prova ogni combinazione risalendo da
     1 pezzo fino a quanti ne servono, tenendo per ogni numero la spesa minima:
     su numeri cosi' piccoli e' istantaneo e resta giusto qualunque prezzo si
     metta domani.

     Il totale dei pezzi resta ESATTAMENTE quello chiesto: mai una confezione
     piu' grande perche' costa meno, che vorrebbe dire spedire roba non
     ordinata.

     In abbonamento entrano solo le confezioni che l'abbonamento prevede: se una
     confezione non fa parte del piano, metterla vorrebbe dire spezzare
     l'abbonamento a meta'. */
  function combinazione(confezioni, pezzi, piano) {
    var utili = (confezioni || []).filter(function (c) {
      if (!c || !(c.pezzi > 0) || c.disponibile === false) return false;
      /* In abbonamento entra ogni confezione che UN abbonamento ce l'ha, non
         solo quella che condivide l'identificativo con la riga: con un piano
         per confezione, pretendere lo stesso identificativo lasciava in gioco
         una confezione sola e il carrello non sapeva piu' raggruppare. */
      if (piano) return !!(c.piani && Object.keys(c.piani).length);
      return true;
    });
    if (!utili.length || pezzi <= 0) return null;

    /* A PARITA' DI SPESA VINCONO MENO CONFEZIONI (27/09/2026). Lo spray costa
       10 / 20 / 30: la confezione da 3 costa quanto tre da uno, e senza questo
       spareggio vinceva la prima trovata, cioe' la singola. Risultato: aggiunta
       la confezione da 3, il carrello la smontava in «3 x 1 spray» con tre o
       quattro viaggi in piu' a Shopify, e lui lo vedeva lento. Sui diffusori la
       confezione grande costa sempre meno, quindi per loro non cambia niente. */
    var spesa = [0];
    var presa = [null];
    var quante = [0];
    for (var n = 1; n <= pezzi; n++) {
      spesa[n] = Infinity;
      presa[n] = null;
      quante[n] = Infinity;
      for (var i = 0; i < utili.length; i++) {
        var c = utili[i];
        if (c.pezzi <= n && spesa[n - c.pezzi] < Infinity) {
          var t = spesa[n - c.pezzi] + prezzoDi(c, piano);
          var q = quante[n - c.pezzi] + 1;
          if (t < spesa[n] || (t === spesa[n] && q < quante[n])) { spesa[n] = t; presa[n] = c; quante[n] = q; }
        }
      }
    }
    if (spesa[pezzi] === Infinity) return null;

    var conti = {};
    var resto = pezzi;
    while (resto > 0) {
      var scelta = presa[resto];
      conti[scelta.id] = (conti[scelta.id] || 0) + 1;
      resto -= scelta.pezzi;
    }
    return conti;
  }

  /* IN ABBONAMENTO UNA CONFEZIONE SOLA (28/09/2026, lui: «l'abbonamento si puo'
     comprare solo 1, 2, 4, 6»). I piani di Kaching sono uno per confezione: due
     confezioni in abbonamento sono due piani, e forse due abbonamenti separati
     con due addebiti al mese. Quindi in abbonamento il carrello tiene UNA
     confezione: quella da quei pezzi o, se non esiste (1 + 2 aggiunte dalla
     scheda = 3), la piu' piccola che li contiene (la 4, che oggi costa anche
     meno di 2 + 1); oltre la piu' grande resta la piu' grande. */
  function unaConfezione(confezioni, pezzi) {
    var abbonabili = (confezioni || []).filter(function (c) {
      return c && c.pezzi > 0 && c.disponibile !== false && c.piani && Object.keys(c.piani).length;
    }).sort(function (a, b) { return a.pezzi - b.pezzi; });
    if (!abbonabili.length || pezzi <= 0) return null;
    var scelta = abbonabili[abbonabili.length - 1];
    for (var i = 0; i < abbonabili.length; i++) {
      if (abbonabili[i].pezzi >= pezzi) { scelta = abbonabili[i]; break; }
    }
    var conti = {};
    conti[scelta.id] = 1;
    return conti;
  }

  function leggiRighe(riga) {
    try { return JSON.parse(riga.getAttribute('data-righe') || '[]'); } catch (e) { return []; }
  }

  function uguali(righe, conti) {
    var ora = {};
    righe.forEach(function (r) { ora[r.v] = (ora[r.v] || 0) + r.q; });
    var chiavi = {};
    Object.keys(ora).forEach(function (k) { chiavi[k] = true; });
    Object.keys(conti).forEach(function (k) { chiavi[k] = true; });
    return Object.keys(chiavi).every(function (k) {
      return (ora[k] || 0) === (conti[k] || 0);
    });
  }

  /* Porta il gruppo alla combinazione voluta lavorando RIGA PER RIGA, con le
     chiavi del carrello.

     Prima si aggiunge quello che manca, poi si sistema quello che c'e' gia'.
     L'ordine non e' casuale: al contrario, se l'aggiunta fallisse a meta' il
     cliente si ritroverebbe il carrello svuotato invece che intatto.

     Le righe che ci sono gia' si toccano SEMPRE per chiave, mai per numero di
     variante: la stessa variante puo' stare nel carrello due volte, una in
     abbonamento e una no, e un aggiornamento per variante le confonderebbe.
     (/cart/update.js accetta anche le chiavi: vedi piu' sotto dove lo si usa.) */
  function applica(riga, conti, piano, confezioni, soloPassi) {
    var righe = leggiRighe(riga);
    var presenti = {};
    righe.forEach(function (r) { presenti[r.v] = true; });

    /* Ogni confezione va aggiunta CON IL SUO piano, non con quello della riga
       di partenza: passando da una confezione da uno a una da due, il piano
       giusto e' quello della confezione da due, se no Shopify rifiuta la riga
       o applica il prezzo sbagliato. */
    var perId = {};
    (confezioni || []).forEach(function (c) { perId[String(c.id)] = c; });

    var daAggiungere = [];
    Object.keys(conti).forEach(function (id) {
      if (presenti[id]) return;
      var voce = { id: Number(id), quantity: conti[id] };
      var suo = pianoDi(perId[id], piano);
      if (suo) voce.selling_plan = Number(suo);
      daAggiungere.push(voce);
    });

    /* I REGALI VIAGGIANO CON LA MODIFICA (06/10/2026). Quelli che questa
       modifica porta o toglie si sistemano NELL'ULTIMA richiesta, insieme
       all'ultima riga: nessuna richiesta in piu', e il pannello che torna e'
       gia' giusto (mai un totale con dentro un regalo da pagare). */
    var coiRegali = regaliPrevisti(riga, conti);
    var conRegali = Object.keys(coiRegali).length > 0;

    var cambi = [];
    righe.forEach(function (r) {
      var voluta = conti[r.v] || 0;
      if (voluta === r.q) return;
      cambi.push({ k: r.k, q: voluta, v: r.v });
    });

    /* /cart/update.js con una chiave che non vale piu' NON si ferma: ripiega
       sul numero di variante e tocca la prima riga che ce l'ha (misurato).
       Se quella variante sta anche in un'altra riga del pannello (la stessa
       confezione in abbonamento e in acquisto singolo) potrebbe toccare
       quella sbagliata: in quel caso update.js non si usa, si resta su
       change.js, che con una chiave morta risponde errore e non tocca niente. */
    var altrove = variantiPresenti(riga);
    function solaQui(variante) { return !altrove[String(variante)]; }

    /* I passi si mettono in fila PRIMA di partire, cosi' si sa qual e' l'ultimo:
       solo a quello si chiede anche il pannello ridisegnato. Ai passi in mezzo
       non serve — verrebbero renderizzati per niente e rallenterebbero. */
    function aPassi() {
      var passi = [];
      if (daAggiungere.length) {
        passi.push(function (conSezione) { return aggiungiVoci(daAggiungere, conSezione); });
      }
      cambi.forEach(function (c, i) {
        var insieme = conRegali && i === cambi.length - 1 && solaQui(c.v);
        passi.push(function (conSezione) {
          return insieme ? cambiaConRegali(c, coiRegali, conSezione) : cambiaChiave(c.k, c.q, conSezione);
        });
      });

      if (!passi.length) return Promise.resolve();

      /* Uno alla volta: due riscritture in parallelo sullo stesso carrello si
         sovrascrivono a vicenda. La catena si risolve col risultato dell'ultimo
         passo, che porta dentro la sezione gia' pronta. */
      return passi.reduce(function (catena, passo, i) {
        var ultimo = i === passi.length - 1;
        return catena.then(function () { return passo(ultimo); });
      }, Promise.resolve());
    }

    /* IN ACQUISTO SINGOLO, UN VIAGGIO SOLO (06/10/2026, lui: «se riesci a farlo
       diventare anche piu' veloce di adesso sarebbe meglio»). Cambiare
       confezione voleva dire due richieste in fila: aggiungi la nuova, togli la
       vecchia. /cart/update.js sa fare tutto insieme — la confezione nuova per
       numero di variante, la vecchia per chiave, i regali — e il tempo del piu'
       e del meno si dimezza.
       Solo quando si puo' fare senza rischi:
       - la confezione nuova non ha un piano (update.js non sa metterlo: in
         abbonamento restano i due viaggi);
       - ne' la confezione nuova ne' quelle vecchie stanno anche in un'altra
         riga del pannello (la stessa confezione in abbonamento): update.js
         per variante cambierebbe QUELLA riga invece di aggiungerne una nuova;
       - non e' il secondo lavoro di un accorpamento (`soloPassi`): il
         pannello in pagina a quel punto e' vecchio e i controlli non valgono.
       Se Shopify la RIFIUTA si rifa' coi due viaggi di sempre. Se invece cade
       la rete NON si riprova: la richiesta potrebbe essere arrivata lo stesso,
       e rifarla coi due passi aggiungerebbe la confezione una seconda volta.
       L'errore sale a chi ha chiamato, che ridisegna il carrello vero. */
    var inUno = !soloPassi && daAggiungere.length > 0 && cambi.length > 0 &&
      daAggiungere.every(function (v) { return !v.selling_plan && solaQui(v.id); }) &&
      cambi.every(function (c) { return solaQui(c.v); });
    if (!inUno) return aPassi();

    var quantita = {};
    daAggiungere.forEach(function (v) { quantita[v.id] = v.quantity; });
    cambi.forEach(function (c) { quantita[c.k] = c.q; });
    Object.keys(coiRegali).forEach(function (id) { quantita[id] = coiRegali[id]; });
    return aggiornaInsieme(quantita, true).catch(function (e) {
      if (e && e.rifiutata) return aPassi();
      throw e;
    });
  }

  /* Le varianti che stanno nel carrello nelle ALTRE righe del pannello
     (tutte, se non si dice quale riga lasciare fuori). */
  function variantiPresenti(esclusa) {
    var tutte = {};
    Array.prototype.forEach.call(document.querySelectorAll('[data-ppz-riga]'), function (riga) {
      if (riga === esclusa) return;
      leggiRighe(riga).forEach(function (r) { tutte[String(r.v)] = true; });
    });
    return tutte;
  }

  /* Piu' quantita' in una richiesta sola: chiavi di riga e numeri di variante
     insieme, quantita' assolute. Una variante che non c'e' viene aggiunta.
     Se Shopify risponde di no l'errore porta `rifiutata`: e' il solo caso in
     cui si sa per certo che il carrello non e' cambiato. */
  function aggiornaInsieme(quantita, conSezione) {
    var corpo = { updates: quantita };
    if (conSezione) corpo.sections = SEZIONE;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      if (!r.ok) {
        var errore = new Error('insieme');
        errore.rifiutata = true;
        return Promise.reject(errore);
      }
      return r.json();
    });
  }

  function aggiungiVoci(voci, conSezione) {
    var corpo = { items: voci };
    if (conSezione) corpo.sections = SEZIONE;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (x) { return Promise.reject(x); });
      return r.json();
    });
  }

  function cambiaChiave(chiave, quantita, conSezione) {
    var corpo = { id: chiave, quantity: quantita };
    if (conSezione) corpo.sections = SEZIONE;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    })
      /* Il numerino non si tocca qui: item_count conta le righe, non i pezzi.
         Lo aggiorna il ridisegno, con il conto fatto da Liquid. */
      .then(function (r) { return r.json(); });
  }

  /* L'ultima riga di una modifica E i regali, in una richiesta sola.
     /cart/update.js accetta insieme la chiave di una riga e il numero di
     variante dei regali (provato dal vero, anche con una riga in abbonamento);
     le quantita' sono assolute. Se per qualunque motivo non passa, la riga si
     cambia come sempre e ai regali si pensa dopo: la modifica del cliente non
     deve mai saltare per colpa di un regalo. */
  function cambiaConRegali(cambio, regali, conSezione) {
    var quantita = {};
    quantita[cambio.k] = cambio.q;
    Object.keys(regali).forEach(function (id) { quantita[id] = regali[id]; });
    return aggiornaInsieme(quantita, conSezione)
      .catch(function () { return cambiaChiave(cambio.k, cambio.q, conSezione); });
  }

  /* Porta un prodotto al numero di pezzi chiesto, scegliendo le confezioni.
     Vale allo stesso modo per l'acquisto singolo e per l'abbonamento: cambia
     solo il listino con cui si fanno i conti, e chi e' abbonato resta abbonato
     perche' le confezioni nuove si aggiungono col piano addosso. */
  function imposta(riga, pezzi) {
    var confezioni = scala()[riga.getAttribute('data-prodotto')];
    var piano = riga.getAttribute('data-piano') || '';

    if (!confezioni) return sempliceCambio(riga, pezzi);

    if (pezzi <= 0) return applica(riga, {}, piano, confezioni);

    var conti = piano
      ? unaConfezione(confezioni, pezzi)
      : combinazione(confezioni, Math.min(pezzi, MAX_PEZZI), piano);
    /* Se in abbonamento non esiste una combinazione (per esempio il piano copre
       solo certe confezioni) si ripiega sulla quantita', invece di rompere
       l'abbonamento o non fare niente. */
    if (!conti) return sempliceCambio(riga, pezzi);
    return applica(riga, conti, piano, confezioni);
  }

  /* Ripiego per i casi che le confezioni non sanno gestire: si muove la
     quantita' della riga di uno, come farebbe un carrello qualsiasi. */
  function sempliceCambio(riga, pezzi) {
    var righe = leggiRighe(riga);
    if (!righe.length) return Promise.resolve();
    if (pezzi <= 0) {
      return righe.reduce(function (catena, r, i) {
        var ultimo = i === righe.length - 1;
        return catena.then(function () { return cambiaChiave(r.k, 0, ultimo); });
      }, Promise.resolve());
    }
    var ora = parseInt(riga.getAttribute('data-pezzi'), 10) || 0;
    var qta = parseInt(riga.getAttribute('data-qta'), 10) || 0;
    return cambiaChiave(righe[0].k, Math.max(0, qta + (pezzi - ora)), true);
  }

  /* Dopo un'aggiunta: se qualcuno ha messo due volte la confezione singola,
     qui il carrello si accorpa da solo sulla confezione da due. Si tocca solo
     quando serve davvero, cosi' l'aggiunta normale resta una sola chiamata. */
  function accorpa() {
    var tabella = scala();
    var lavori = [];

    Array.prototype.forEach.call(document.querySelectorAll('[data-ppz-riga]'), function (riga) {
      var confezioni = tabella[riga.getAttribute('data-prodotto')];
      if (!confezioni) return;
      var piano = riga.getAttribute('data-piano') || '';

      var pezzi = parseInt(riga.getAttribute('data-pezzi'), 10) || 0;
      var conti = piano
        ? unaConfezione(confezioni, pezzi)
        : combinazione(confezioni, Math.min(pezzi, MAX_PEZZI), piano);
      if (!conti) return;
      if (uguali(leggiRighe(riga), conti)) return;

      lavori.push({ riga: riga, conti: conti, piano: piano, confezioni: confezioni });
    });

    if (!lavori.length) return Promise.resolve(false);
    /* Uno alla volta: due riscritture in parallelo sullo stesso carrello si
       sovrascrivono a vicenda.
       Risponde con la risposta dell'ULTIMA modifica, che porta gia' dentro il
       pannello ridisegnato (o `true` se non c'e'): chi chiama non deve fare un
       altro viaggio per ridisegnare. */
    return lavori.reduce(function (catena, l, i) {
      return catena.then(function () { return applica(l.riga, l.conti, l.piano, l.confezioni, i > 0); });
    }, Promise.resolve()).then(function (ultima) { return ultima || true; });
  }

  /* --- I regali veri --------------------------------------------------------

     DAL 06/10/2026 GUIDA E SPRAY SONO PRODOTTI VERI (tipo «Regalo»), cosi' si
     vedono al checkout, nell'ordine e nelle email. In Shopify costano ZERO
     (col prezzo di confronto), ma nel carrello non ci entrano da soli: ce li
     mette questo file, e li toglie quando il carrello non li merita piu'.
     (Per qualche ora costavano 9,90 / 19,90 e li azzeravano degli sconti
     automatici: la cassa scriveva il titolo dello sconto sotto ogni riga, e
     lui li ha fatti togliere.)

     La regola non sta qui: la sezione stampa un blocco di dati con i regali
     VOLUTI (quelli che disegna) e quelli PRESENTI (le righe vere, con quanto
     costano davvero). Qui si confrontano i due elenchi e, SOLO se sono
     diversi, si fa UNA richiesta che li pareggia. Quantita' assolute, mai
     «aggiungi»: rifare la stessa richiesta due volte non raddoppia niente.

     UN REGALO NON SI PAGA MAI. Oggi costa zero e non puo' succedere; ma se un
     giorno in Admin gli si rimette un prezzo, un regalo che non risulta
     gratis lo si toglie e con QUESTO carrello non lo si rimette: meglio un
     regalo mancante che 9,90 euro in piu' nel totale. Il rifiuto vale finche' i prodotti comprati restano
     gli stessi (la «firma» stampata dalla sezione): cambiata la confezione si
     riprova. Si ricorda in sessionStorage, se no sulla pagina carrello — che
     dopo un allineamento si ricarica — girerebbe all'infinito; e anche in una
     variabile, per i browser dove sessionStorage non si puo' scrivere.

     VELOCE E PRECISO COME PRIMA (06/10/2026, lui: «il carrello deve avere la
     stessa precisione e velocita' di prima»). La prima versione faceva una
     richiesta in piu' dopo ogni tocco, a pannello fermo, e togliendo un regalo
     mostrava per un attimo il totale col regalo a pagamento. Ora:
     - piu', meno e cestino: i regali viaggiano DENTRO l'ultima richiesta della
       modifica (`regaliPrevisti` + `cambiaConRegali`). Stesse richieste di
       prima, e il pannello che torna e' gia' giusto;
     - aggiunta dalla pagina: il pannello si libera come prima, e i regali
       entrano subito dopo, da soli (`programmaRegali`). A vedersi non cambia
       niente — le righe regalo sono disegnate dalla regola e valgono zero —
       quindi non si ridisegna: si aggiornano solo i dati (`soloDati`);
     - mai due scritture insieme: ogni modifica aspetta che l'allineamento in
       corso abbia finito (`dopoRegali`), e la cassa pure. */
  var CHIAVE_RIFIUTATI = 'ppz-regali-no';
  var rifiutatiQui = {};
  var scritture = 0;
  var regaliTimer = null;
  var regaliInVolo = null;

  function rifiutati(firma) {
    var salvati = {};
    try { salvati = JSON.parse(window.sessionStorage.getItem(CHIAVE_RIFIUTATI) || '{}') || {}; } catch (e) { salvati = {}; }
    var no = {};
    [salvati, rifiutatiQui].forEach(function (elenco) {
      Object.keys(elenco).forEach(function (id) { if (elenco[id] === firma) no[id] = 1; });
    });
    return no;
  }

  function rifiuta(id, firma) {
    rifiutatiQui[id] = firma;
    try {
      var r = JSON.parse(window.sessionStorage.getItem(CHIAVE_RIFIUTATI) || '{}') || {};
      r[id] = firma;
      window.sessionStorage.setItem(CHIAVE_RIFIUTATI, JSON.stringify(r));
    } catch (e) {}
  }

  function datiRegali() {
    var el = document.querySelector('[data-ppz-cart-regali]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* Cosa va cambiato per pareggiare voluti e presenti: variante -> quantita'.
     Vuoto = tutto a posto. `segna`: ricordare i regali trovati a pagamento. */
  function cambiRegali(dati, segna) {
    var voluti = dati.voluti || {};
    var presenti = dati.presenti || {};
    var firma = dati.firma || '';
    var no = rifiutati(firma);
    var cambi = {};

    Object.keys(presenti).forEach(function (id) {
      var p = presenti[id] || {};
      var vuole = voluti[id] && !no[id] ? 1 : 0;
      /* «A pagamento» si giudica con UN pezzo solo. Se ce ne sono due (alzato
         dalla pagina carrello) il secondo si paga per forza: lo si riporta a
         uno e lo si giudica al giro dopo. */
      if (vuole && p.q === 1 && p.paga > 0) {
        if (segna) rifiuta(id, firma);
        vuole = 0;
      }
      if ((p.q || 0) !== vuole) cambi[id] = vuole;
    });
    Object.keys(voluti).forEach(function (id) {
      if (presenti[id] || no[id]) return;
      cambi[id] = 1;
    });
    return cambi;
  }

  function daAllineare() {
    var dati = datiRegali();
    return !!dati && Object.keys(cambiRegali(dati, false)).length > 0;
  }

  /* QUALI REGALI CAMBIERANNO se la riga `rigaCambiata` passa alle confezioni
     `conti` (variante -> quante). Risponde variante regalo -> quantita' (1 o
     0), solo per quelli da mettere o da togliere.

     La regola resta della sezione: nel blocco dei regali c'e' "regola", per
     ogni regalo la specie e da quanti pezzi scatta. Qui si contano soltanto i
     pezzi che RESTERANNO nel carrello, per specie, sommati su tutte le righe
     (2 in abbonamento + 1 singolo = 3), come fa la sezione.
     Se la previsione sbaglia non succede niente di grave: dopo ogni risposta
     comanda di nuovo il blocco stampato dalla sezione (`ridisegnaGiusto`,
     `avviaRegali`). */
  function regaliPrevisti(rigaCambiata, conti) {
    var esito = {};
    var dati = datiRegali();
    if (!dati || !dati.regola) return esito;

    var tabella = scala();
    var somme = {};
    Array.prototype.forEach.call(document.querySelectorAll('[data-ppz-riga]'), function (riga) {
      var da = riga.getAttribute('data-da');
      if (!da) return;
      var chiave = riga.getAttribute('data-specie') + '|' + da;
      var pezziDi = {};
      (tabella[riga.getAttribute('data-prodotto')] || []).forEach(function (c) { pezziDi[String(c.id)] = c.pezzi; });

      var varianti = {};
      if (riga === rigaCambiata) {
        varianti = conti || {};
      } else {
        leggiRighe(riga).forEach(function (r) { varianti[r.v] = (varianti[r.v] || 0) + r.q; });
      }
      Object.keys(varianti).forEach(function (id) {
        if (!(varianti[id] > 0)) return;
        somme[chiave] = (somme[chiave] || 0) + (pezziDi[String(id)] || 1) * varianti[id];
      });
    });

    var presenti = dati.presenti || {};
    Object.keys(dati.regola).forEach(function (id) {
      var r = dati.regola[id] || {};
      /* 19/10/2026: anche le ricariche danno la guida (righe con data-da="ricariche"). */
      var vuole =
        (r.diffusori > 0 && (somme[r.specie + '|diffusori'] || 0) >= r.diffusori) ||
        (r.spray > 0 && (somme[r.specie + '|spray'] || 0) >= r.spray) ||
        (r.ricariche > 0 && (somme[r.specie + '|ricariche'] || 0) >= r.ricariche);
      var ora = (presenti[id] && presenti[id].q) || 0;
      if (vuole && ora !== 1) esito[id] = 1;
      if (!vuole && ora > 0) esito[id] = 0;
    });
    return esito;
  }

  /* Il blocco dei regali dentro una sezione appena arrivata, senza metterla
     in pagina. */
  function datiDa(html) {
    /* Si pesca il blocco dal testo, senza far leggere al browser tutta la
       sezione una volta in piu': su un telefono lento sono millisecondi veri. */
    var trovato = /<script[^>]*data-ppz-cart-regali[^>]*>([\s\S]*?)<\/script>/.exec(html || '');
    if (!trovato) return null;
    try { return JSON.parse(trovato[1]); } catch (e) { return null; }
  }

  /* I regali che in questi dati sono DI TROPPO (non piu' meritati, o non
     gratis): finche' restano nel carrello gonfiano il totale. */
  function diTroppo(dati) {
    var cambi = cambiRegali(dati, true);
    var presenti = dati.presenti || {};
    var giu = {};
    Object.keys(cambi).forEach(function (id) {
      if (presenti[id] && cambi[id] < (presenti[id].q || 0)) giu[id] = cambi[id];
    });
    return Object.keys(giu).length ? giu : null;
  }

  /* MAI UN TOTALE SBAGLIATO SULLO SCHERMO. Se nel pannello appena arrivato c'e'
     un regalo di troppo — la previsione non l'aveva tolto — non lo si mostra:
     prima si toglie il regalo, poi si disegna il carrello vero. Costa una
     richiesta, ma solo in quel caso: di norma i regali sono gia' a posto e
     questo e' il ridisegno di sempre. */
  function ridisegnaGiusto(risposta, giro) {
    giro = giro || 0;
    var html = risposta && risposta.sections && risposta.sections[SEZIONE];
    if (!html) return ridisegna(risposta);
    var dati = giro < 2 ? datiDa(html) : null;
    var giu = dati ? diTroppo(dati) : null;
    if (!giu) return applicaHtml(html);

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: giu, sections: SEZIONE })
    })
      .then(function (r) {
        if (!r.ok) return Promise.reject(new Error('regali'));
        return r.json();
      })
      .then(function (nuova) {
        scritture++;
        return ridisegnaGiusto(nuova, giro + 1);
      })
      .catch(function () { return applicaHtml(html); });
  }

  /* Quello che il cliente vede di un pannello: pezzi, totale, numero di righe. */
  function aspetto(el) {
    var totale = el.querySelector('.ppz-cart__cta-total');
    return [
      el.getAttribute('data-pezzi-totali') || '',
      totale ? totale.textContent.replace(/\s+/g, '') : '',
      el.querySelectorAll('.ppz-cart__item').length
    ].join('|');
  }

  /* DOPO UN ALLINEAMENTO DEI REGALI IL PANNELLO, A VEDERSI, E' LO STESSO: non
     lo si ridisegna (sarebbe un secondo lampo per niente), si aggiornano solo
     i due blocchi di dati. Se invece e' cambiato qualcosa che si vede — il
     totale, i pezzi, le righe — allora si' che si ridisegna. */
  function soloDati(risposta) {
    var html = risposta && risposta.sections && risposta.sections[SEZIONE];
    if (!html || !trova()) return ridisegna(risposta);
    var nuovo = null;
    try { nuovo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ppz-cart-swap]'); } catch (e) { nuovo = null; }
    var vecchio = radice.querySelector('[data-ppz-cart-swap]');
    if (!nuovo || !vecchio || aspetto(nuovo) !== aspetto(vecchio)) return applicaHtml(html);

    /* LE CHIAVI DELLE RIGHE CAMBIANO COI REGALI (misurato il 06/10/2026): quando
       uno sconto «In regalo…» comincia o smette di valere, Shopify da' alla
       riga del diffusore una chiave nuova. Le righe in pagina devono averla,
       se no il prossimo piu' o meno lavorerebbe su una riga che non esiste
       piu'. Si ricopiano i dati delle righe, una per una; se le righe non
       combaciano si ridisegna tutto. */
    var righeVecchie = vecchio.querySelectorAll('[data-ppz-riga]');
    var righeNuove = nuovo.querySelectorAll('[data-ppz-riga]');
    if (righeVecchie.length !== righeNuove.length) return applicaHtml(html);
    var i;
    for (i = 0; i < righeVecchie.length; i++) {
      if (righeVecchie[i].getAttribute('data-prodotto') !== righeNuove[i].getAttribute('data-prodotto') ||
          righeVecchie[i].getAttribute('data-piano') !== righeNuove[i].getAttribute('data-piano')) {
        return applicaHtml(html);
      }
    }
    for (i = 0; i < righeVecchie.length; i++) {
      ['data-righe', 'data-pezzi', 'data-qta'].forEach(function (nome) {
        righeVecchie[i].setAttribute(nome, righeNuove[i].getAttribute(nome) || '');
      });
    }
    ['[data-ppz-cart-regali]', '[data-ppz-cart-scala]'].forEach(function (blocco) {
      var a = vecchio.querySelector(blocco);
      var b = nuovo.querySelector(blocco);
      if (a && b) a.textContent = b.textContent;
    });
    return Promise.resolve();
  }

  function allineaRegali(giro) {
    giro = giro || 0;
    var dati = datiRegali();
    /* Niente blocco = carrello vuoto: non si scrive su un carrello che non
       esiste (ne nascerebbe uno nuovo, vedi ppz-meta.js). */
    if (!dati) return Promise.resolve();

    var cambi = cambiRegali(dati, true);

    /* Tre giri al massimo: metti, controlla che sia gratis, e basta. A regime
       il primo giro non trova differenze e non parte nessuna richiesta. Dopo
       il terzo si puo' solo TOGLIERE: comunque sia andata, nel carrello non
       resta un regalo che non ci deve stare. */
    if (giro >= 3) {
      Object.keys(cambi).forEach(function (id) { if (cambi[id] !== 0) delete cambi[id]; });
    }
    if (!Object.keys(cambi).length || giro >= 5) return Promise.resolve();

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: cambi, sections: SEZIONE })
    })
      .then(function (r) {
        if (!r.ok) return Promise.reject(new Error('regali'));
        return r.json();
      })
      .then(function (risposta) {
        scritture++;
        return soloDati(risposta);
      })
      .then(function () { return allineaRegali(giro + 1); });
  }

  /* LE RIGHE REGALO SONO DISEGNATE dalla regola, non dal carrello. Se alla fine
     il regalo vero non c'e' (rifiutato, richiesta fallita) la riga si
     nasconde: non si promette uno spray che nell'ordine non c'e', e che il
     fornitore quindi non spedisce. */
  function soloRegaliVeri() {
    var dati = datiRegali();
    var presenti = (dati && dati.presenti) || {};
    Array.prototype.forEach.call(document.querySelectorAll('[data-ppz-regalo]'), function (riga) {
      var p = presenti[riga.getAttribute('data-ppz-regalo')];
      riga.hidden = !(p && p.q > 0 && !(p.paga > 0));
    });
  }

  /* Come sopra, ma non fa mai fallire la catena che lo chiama: se i regali non
     si allineano il carrello resta valido lo stesso. Un errore solo (la rete
     che salta un attimo) non deve pero' lasciare nel carrello un regalo da
     pagare: si riprova una volta. Risponde `true` se ha cambiato il carrello. */
  function regali() {
    var prima = scritture;
    return allineaRegali()
      .catch(function () {
        return new Promise(function (ok) { window.setTimeout(ok, 900); })
          .then(function () { return allineaRegali(); });
      })
      .catch(function () {})
      .then(function () {
        soloRegaliVeri();
        return scritture !== prima;
      });
  }

  /* Un regalo rifiutato con questo carrello non entrera': la sua riga
     disegnata si nasconde subito, a ogni ridisegno, senza aspettare. */
  function nascondiRifiutati() {
    var dati = datiRegali();
    if (!dati) return;
    var no = rifiutati(dati.firma || '');
    Array.prototype.forEach.call(document.querySelectorAll('[data-ppz-regalo]'), function (riga) {
      if (no[riga.getAttribute('data-ppz-regalo')]) riga.hidden = true;
    });
  }

  /* L'ALLINEAMENTO GIRA DA SOLO, A PANNELLO LIBERO. Dopo ogni modifica lo si
     mette in programma; parte subito, e solo se serve davvero (quasi mai:
     piu', meno e cestino i regali se li portano gia' dietro). Subito e non
     dopo un'attesa: dopo un'aggiunta dalla pagina, prima i regali sono nel
     carrello e meno rischia di aspettare chi clicca in fretta sulla cassa. */
  function programmaRegali() {
    window.clearTimeout(regaliTimer);
    regaliTimer = window.setTimeout(function () {
      regaliTimer = null;
      avviaRegali();
    }, 0);
  }

  function avviaRegali() {
    if (regaliInVolo) return regaliInVolo;
    /* Una modifica e' in corso: i regali li chiude lei, alla fine. */
    if (lavori > 0) return Promise.resolve(false);
    if (!daAllineare()) {
      soloRegaliVeri();
      return Promise.resolve(false);
    }
    regaliInVolo = regali().then(function (cambiato) {
      regaliInVolo = null;
      return cambiato;
    });
    return regaliInVolo;
  }

  /* Da chiamare all'inizio di ogni modifica: ferma l'allineamento che doveva
     ancora partire e aspetta quello gia' partito (al massimo quattro secondi:
     una richiesta che non torna non deve bloccare il carrello). */
  function dopoRegali() {
    window.clearTimeout(regaliTimer);
    regaliTimer = null;
    if (!regaliInVolo) return Promise.resolve();
    return Promise.race([
      regaliInVolo,
      new Promise(function (ok) { window.setTimeout(ok, 4000); })
    ]);
  }

  /* --- Conto alla rovescia ------------------------------------------------- */

  /* Parte alla prima apertura e se lo ricorda per tutta la visita: se ripartisse
     da capo a ogni apertura si vedrebbe che non e' una vera scadenza. */
  function avviaConto() {
    window.clearInterval(conto);
    if (!radice) return;
    var riga = radice.querySelector('[data-ppz-cart-hold]');
    var vista = radice.querySelector('[data-ppz-cart-timer]');
    if (!riga || !vista) return;

    var minuti = parseInt(riga.getAttribute('data-minuti'), 10) || 15;
    var fine;
    try { fine = parseInt(window.sessionStorage.getItem(CHIAVE_TIMER), 10); } catch (e) { fine = NaN; }

    if (!fine || isNaN(fine) || fine < Date.now()) {
      fine = Date.now() + minuti * 60 * 1000;
      try { window.sessionStorage.setItem(CHIAVE_TIMER, String(fine)); } catch (e) {}
    }

    function passo() {
      var resta = Math.max(0, Math.round((fine - Date.now()) / 1000));
      var m = Math.floor(resta / 60);
      var s = resta % 60;
      vista.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (resta <= 0) {
        window.clearInterval(conto);
        riga.hidden = true;
      }
    }
    passo();
    conto = window.setInterval(passo, 1000);
  }

  /* --- Riga provvisoria (14/10/2026) ---------------------------------------

     Dalla guida del carrello di Meridiano, SOLO la parte che non tocca i soldi.
     Al tocco su «Acquista ora» / «Aggiungi al carrello», se nel carrello non c'e'
     ancora nessun prodotto, al posto di «Il tuo carrello e' vuoto» (che restava li',
     smorzato, 0,7 s e 2,7 s su rete da telefono: misurato sul live) compare subito
     il prodotto scelto: foto, nome e confezione, copiati da un <template> della
     pagina (snippets/ppz-cart-attesa). NIENTE PREZZO, NIENTE QUANTITA', NIENTE
     TOTALE: i numeri li dice solo la risposta di Shopify, che quando arriva
     sostituisce tutto (mettiHtml). E' la lezione del 09/09/2026 (vedi `occupato`):
     un numero scritto prima della risposta ha rotto il carrello tre volte.
     Non compare mai quando:
     - nel carrello c'e' gia' un prodotto: le confezioni si ricompongono e la riga
       vera sarebbe un'altra;
     - si aggiungono piu' pezzi insieme, o il modulo non dice una variante sola;
     - il pannello puo' essere vecchio: la scheda del browser e' stata lasciata e
       ripresa, e il carrello puo' essere cambiato da un'altra parte.
     E' `inert` (non si tocca) e se la richiesta fallisce se ne va (viaProvvisoria). */
  var forseVecchio = false;

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') forseVecchio = true;
  });

  function provvisoria(dati) {
    if (forseVecchio || !trova()) return false;
    var swap = radice.querySelector('[data-ppz-cart-swap]');
    var corpo = swap && swap.querySelector('.ppz-cart__body');
    if (!corpo || swap.querySelector('[data-ppz-riga]')) return false;
    var id = String(dati.get('id') || '');
    if (!/^\d+$/.test(id)) return false;
    var quanti = dati.get('quantity');
    if (quanti !== null && String(quanti) !== '1') return false;
    var modello = document.querySelector('template[data-ppz-attesa="' + id + '"]');
    var riga = modello && modello.content && modello.content.firstElementChild;
    if (!riga) return false;

    Array.prototype.forEach.call(corpo.children, function (figlio) {
      if (figlio.hidden) return;
      figlio.hidden = true;
      figlio.setAttribute('data-ppz-attesa-nascosto', '');
    });
    var lista = document.createElement('ul');
    lista.className = 'ppz-cart__items';
    lista.setAttribute('data-ppz-attesa-lista', '');
    var copia = riga.cloneNode(true);
    copia.setAttribute('inert', '');
    copia.setAttribute('aria-busy', 'true');
    lista.appendChild(copia);
    corpo.insertBefore(lista, corpo.firstChild);

    /* La cima (17/10/2026): sopra le righe il pannello vero ha la riga «riservati» e, coi
       diffusori, la barra del regalo. Qui al loro posto vanno le forme grigie alte uguali
       (<template data-ppz-attesa-cima> del carrello), cosi' quando arriva il pannello vero
       la riga non salta giu'. Delle barre (guida, spray, piena) si tiene quella che la riga
       annuncia (data-barra), o nessuna. Se ne vanno con la provvisoria (data-ppz-attesa-lista). */
    var cima = radice.querySelector('template[data-ppz-attesa-cima]');
    var barra = riga.getAttribute('data-barra') || '';
    if (cima && cima.content) {
      Array.prototype.slice.call(cima.content.children).reverse().forEach(function (pezzo) {
        var tappa = pezzo.getAttribute('data-solo-barra');
        if (tappa !== null && tappa !== barra) return;
        var forma = pezzo.cloneNode(true);
        forma.setAttribute('data-ppz-attesa-lista', '');
        corpo.insertBefore(forma, corpo.firstChild);
      });
    }
    radice.setAttribute('data-attesa', '');
    return true;
  }

  /* Se il pannello vero non e' arrivato (richiesta fallita) si torna com'era. Se
     invece e' arrivato, la provvisoria se n'e' gia' andata con lui: qui non c'e'
     niente da fare. */
  function viaProvvisoria() {
    if (!radice) return;
    radice.removeAttribute('data-attesa');
    Array.prototype.forEach.call(radice.querySelectorAll('[data-ppz-attesa-lista]'), function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
    Array.prototype.forEach.call(radice.querySelectorAll('[data-ppz-attesa-nascosto]'), function (n) {
      n.hidden = false;
      n.removeAttribute('data-ppz-attesa-nascosto');
    });
  }

  /* Un tempo massimo per l'aggiunta: senza, se il telefono perde campo a meta', il
     pannello resterebbe «occupato» fino a quando il browser si arrende (minuti).
     Scaduto il tempo la richiesta si ferma e vale come un rifiuto: si va alla
     pagina carrello vera, che mostra comunque il carrello com'e' davvero.
     Il tempo copre TUTTA la risposta, corpo compreso (revisione del 14/10/2026: il
     corpo, col pannello dentro, puo' bloccarsi dopo che sono arrivate le
     intestazioni). Risponde { ok, dati }. */
  function conTempo(url, opzioni, ms) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? window.setTimeout(function () { ctrl.abort(); }, ms) : null;
    if (ctrl) opzioni.signal = ctrl.signal;
    return fetch(url, opzioni)
      .then(function (r) {
        return r.json().then(function (dati) { return { ok: r.ok, dati: dati }; });
      })
      .then(
        function (esito) { window.clearTimeout(timer); return esito; },
        function (err) { window.clearTimeout(timer); throw err; }
      );
  }

  /* --- Aggiunta al carrello ------------------------------------------------ */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var tasto = form.querySelector('[type="submit"]');
    if (tasto) tasto.disabled = true;

    /* Il pannello ridisegnato si chiede nella STESSA richiesta dell'aggiunta:
       e' l'azione piu' frequente del sito e cosi' fa un viaggio invece di due. */
    var dati = new FormData(form);
    dati.append('sections', SEZIONE);

    /* Il pannello si apre PRIMA della risposta di Shopify: era la richiesta
       esplicita. Dentro resta il carrello di prima, smorzato, finche' non
       arriva quello nuovo; a carrello vuoto, la riga provvisoria (sopra). */
    /* Protetta (revisione del 14/10/2026, notte): la riga provvisoria e' solo un
       aspetto. Se si rompesse, l'aggiunta deve partire lo stesso, come prima. */
    try { provvisoria(dati); } catch (err) { viaProvvisoria(); }
    apri();
    occupato(true);

    /* `dopoRegali`: se i regali si stanno allineando proprio adesso, l'aggiunta
       aspetta che abbiano finito. Quasi sempre non c'e' niente da aspettare. */
    dopoRegali()
      .then(function () {
        return conTempo('/cart/add.js', {
          method: 'POST',
          body: dati,
          headers: { Accept: 'application/json' }
        }, 15000);
      })
      .then(function (esito) {
        if (!esito.ok) return Promise.reject(esito.dati);
        return esito.dati;
      })
      .then(function (risposta) { return ridisegnaGiusto(risposta); })
      /* L'accorpamento ha una catch sua: se fallisce LUI, l'aggiunta era andata
         bene lo stesso e non ha senso sbalzare il cliente sulla pagina carrello.
         Il carrello resta valido, solo non accorpato. */
      .then(function () {
        /* Se l'accorpamento si interrompe (la rete che cade a meta') non si sa
           a che punto e' arrivato: `true` fa ridisegnare il pannello dal
           server, cosi' mostra comunque il carrello vero. */
        return accorpa().catch(function () { return true; });
      })
      /* L'accorpamento risponde gia' col pannello ridisegnato: prima qui si
         faceva un altro viaggio a Shopify solo per ridisegnare. */
      .then(function (esito) {
        if (!esito) return;
        return esito === true ? ridisegna() : ridisegnaGiusto(esito);
      })
      .catch(function () {
        /* Se Shopify rifiuta l'AGGIUNTA (scorte finite, variante sparita) non si
           resta con un pannello che mente: si va alla pagina carrello vera. */
        viaProvvisoria();
        window.location.href = '/cart';
      })
      .then(function () {
        viaProvvisoria();
        occupato(false);
        if (tasto) tasto.disabled = false;
        /* I regali che l'aggiunta si merita entrano ADESSO, a pannello gia'
           libero: il cliente non li aspetta, e a vedersi non cambia niente. */
        programmaRegali();
      });
  });

  /* --- Clic dentro e fuori il pannello ------------------------------------- */

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ppz-cart-close]')) {
      e.preventDefault();
      chiudi();
      return;
    }

    var passo = e.target.closest('[data-ppz-cart-set]');
    if (passo) {
      var riga = passo.closest('[data-ppz-riga]');
      if (!riga) return;
      var pezzi = parseInt(passo.getAttribute('data-ppz-cart-set'), 10);
      if (isNaN(pezzi)) return;

      occupato(true);
      dopoRegali()
        /* I regali che cambiano coi pezzi (tolto il diffusore, guida e spray se
           ne vanno con lui) viaggiano dentro la modifica: vedi `applica`. */
        .then(function () { return imposta(riga, pezzi); })
        /* `imposta` si risolve con la risposta dell'ultima modifica, che porta
           gia' dentro il pannello ridisegnato: qui non si fa un secondo viaggio. */
        .then(function (risposta) { return ridisegnaGiusto(risposta); })
        /* Se Shopify rifiuta — variante ritirata, piano non piu' valido — il
           pannello si rifa' dal server invece di restare com'era: cosi' mostra
           sempre il carrello vero, non quello che credevamo di avere. */
        .catch(function () { return ridisegna(); })
        .then(function () {
          occupato(false);
          programmaRegali();
        });
      return;
    }

    /* LA CASSA NON SI APRE CON UN REGALO FUORI POSTO. Quasi sempre i regali
       sono gia' allineati e il collegamento fa il suo mestiere. Se invece si
       stanno allineando proprio adesso (clic sulla cassa un attimo dopo
       l'aggiunta) o l'ultima richiesta e' fallita, si finisce quello e alla
       cassa si va subito dopo: questione di un momento. */
    var cassa = e.target.closest('.ppz-cart__checkout');
    if (cassa) {
      /* Il tocco si vede subito (14/10/2026): la cassa e' una pagina di Shopify e
         dal tema non si velocizza. Un secondo tocco mentre si sta andando non
         rifa' la richiesta. */
      /* Clic che apre la cassa in un'altra scheda (Ctrl, Cmd, Maiusc, tasto
         centrale): qui non si parte, quindi niente «in partenza» e niente blocco. */
      var altrove = e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
      if (!altrove) {
        if (cassa.classList.contains('is-going')) {
          e.preventDefault();
          return;
        }
        cassa.classList.add('is-going');
        window.setTimeout(function () { cassa.classList.remove('is-going'); }, 8000);
      }
      if (!regaliTimer && !regaliInVolo && !daAllineare()) return;
      e.preventDefault();
      var dove = cassa.href;
      occupato(true);
      dopoRegali()
        .then(function () { return daAllineare() ? regali() : false; })
        .then(function () {
          occupato(false);
          window.location.href = dove;
        });
      return;
    }

    var a = e.target.closest('a[href]');
    if (!a) return;
    var percorso;
    try { percorso = new URL(a.href, window.location.origin).pathname; } catch (err) { return; }
    /* Solo il carrello vero e proprio: /cart/add e /cart/checkout devono
       continuare a funzionare come sempre. */
    if (percorso === '/cart' || percorso === '/cart/') {
      e.preventDefault();
      apri();
      occupato(true);
      dopoRegali()
        .then(function () { return ridisegna(); })
        .then(function () {
          occupato(false);
          programmaRegali();
        });
    }
  });

  /* --- La pagina carrello di Horizon ---------------------------------------

     Sulla pagina /cart le righe non le disegniamo noi, e li' i regali sono
     righe come le altre, col loro piu', meno e cestino. Dopo un allineamento
     la pagina si ricarica (e' lei a mostrare le righe); e ogni volta che
     QUALCUNO scrive sul carrello — i tasti di Horizon — si riguardano i
     regali: tolto il diffusore, guida e spray non restano li' a pagamento. */
  var SULLA_PAGINA_CARRELLO = /\/cart$/.test(window.location.pathname.replace(/\/+$/, ''));
  var CHIAVE_RICARICA = 'ppz-regali-ricarica';

  /* Mai due ricariche di fila, e nessuna se sessionStorage non si puo'
     scrivere: senza memoria la pagina girerebbe all'infinito. */
  function ricaricaPagina() {
    try {
      var ultima = parseInt(window.sessionStorage.getItem(CHIAVE_RICARICA), 10) || 0;
      if (Date.now() - ultima < 4000) return;
      window.sessionStorage.setItem(CHIAVE_RICARICA, String(Date.now()));
    } catch (e) { return; }
    window.location.reload();
  }

  function riguardaPagina() {
    /* Sta gia' lavorando una nostra catena: i regali li chiude lei. */
    if (lavori > 0 || regaliInVolo) return;
    ridisegna()
      .then(function () { return avviaRegali(); })
      .then(function (cambiato) { if (cambiato) ricaricaPagina(); });
  }

  if (SULLA_PAGINA_CARRELLO && window.PerformanceObserver) {
    var daRiguardare = null;
    try {
      /* Le richieste finite, viste dal browser: cosi' non serve sapere come
         Horizon chiama i suoi eventi. */
      new PerformanceObserver(function (elenco) {
        var scritto = elenco.getEntries().some(function (voce) {
          return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(voce.name);
        });
        if (!scritto) return;
        window.clearTimeout(daRiguardare);
        daRiguardare = window.setTimeout(riguardaPagina, 300);
      }).observe({ entryTypes: ['resource'] });
    } catch (e) {}
  }

  /* ALL'APERTURA DELLA PAGINA: un carrello riempito prima di oggi, o cambiato
     dalla pagina carrello di Horizon, puo' avere i regali disallineati. Si
     guarda una volta, col pannello stampato dal server: se voluti e presenti
     coincidono (quasi sempre) non parte nessuna richiesta. Gira a pannello
     libero come ogni altro allineamento; un'aggiunta al carrello partita nel
     frattempo lo aspetta (`dopoRegali`). */
  function regaliAllAvvio() {
    if (!trova() || !datiRegali()) return;
    avviaRegali().then(function (cambiato) {
      if (cambiato && SULLA_PAGINA_CARRELLO) ricaricaPagina();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', regaliAllAvvio);
  } else {
    regaliAllAvvio();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && radice && !radice.hidden) chiudi();
  });

  /* Tornando indietro dalla cassa (la pagina esce dalla memoria del browser) il
     pulsante non deve restare «in partenza». */
  window.addEventListener('pageshow', function (e) {
    Array.prototype.forEach.call(document.querySelectorAll('.ppz-cart__checkout.is-going'), function (b) {
      b.classList.remove('is-going');
    });
    /* Pagina tornata dalla memoria del browser: il pannello stampato puo' essere
       vecchio, quindi niente riga provvisoria finche' non si ridisegna. */
    if (e.persisted) forseVecchio = true;
  });

  /* LE FOTO DEL CARRELLO IN MEMORIA, DOPO IL CARICAMENTO (14/10/2026). Le pagine
     che vendono hanno in un <template> le stesse foto della riga del carrello
     (snippets/ppz-cart-attesa): messe in pagina a caricamento finito non rubano
     banda alla foto grande, e quando il carrello si apre la foto c'e' gia'. */
  function precaricaFoto() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ppz-cart-prefetch] > template'), function (t) {
      if (t.parentNode) t.parentNode.appendChild(t.content.cloneNode(true));
      t.remove();
    });
  }

  if (document.readyState === 'complete') {
    window.setTimeout(precaricaFoto, 0);
  } else {
    window.addEventListener('load', function () { window.setTimeout(precaricaFoto, 0); });
  }
})();
